import React from "react";

const WORDS = [
  "Endoscopic Spine Surgery",
  "Minimally Invasive",
  "Neurosurgery",
  "Patient-First Care",
  "Evidence-Based",
];

const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="marquee" className="bg-brand-light py-10 overflow-hidden border-y border-slate-200">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <div key={`${w}-${i >= WORDS.length ? "b" : "a"}-${i % WORDS.length}`} className="flex items-center">
            <span className="font-heading font-extrabold text-4xl md:text-6xl tracking-tight text-brand/[0.14] px-8">
              {w}
            </span>
            <span className="w-2 h-2 rounded-full bg-brand/40" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
